import { Iso2Country } from "@gymflow/types";
import { DateTime } from "luxon";
import { z } from "zod";

import { validatePhoneNumber } from "./lib/helpers/phoneNumber";
import { validatePostCode } from "./lib/helpers/postCode";

const MemberSchema = (country: Iso2Country) =>
  z
    .object({
      mobileNumber: z
        .string()
        .optional()
        .refine((e) => !e || validatePhoneNumber(e), {
          message: "validation.phoneNumber",
        }),
      dateBirth: z
        .string()
        .optional()
        .refine(
          (e) => {
            return e === undefined || DateTime.fromISO(e) < DateTime.now();
          },
          {
            message: "validation.dateTooBig",
            params: {
              maximum: DateTime.now().toLocaleString(DateTime.DATE_MED),
            },
          },
        ),
      gender: z.enum(["MALE", "FEMALE", "PREFER_NOT_TO_SAY"]).optional(),
      personalNumber: z.string().optional(),
      addressLine1: z.string().min(3).optional(),
      addressLine2: z.string().optional(),
      postCode: z
        .string()
        .optional()
        .refine((e) => !e || validatePostCode(e, country), {
          message: "validation.postCode",
        }),
      city: z.string().min(3).optional(),
      emergencyContactName: z.string().min(3).optional(),
      emergencyContact: z
        .string()
        .optional()
        .refine((e) => !e || validatePhoneNumber(e), {
          message: "validation.phoneNumber",
        }),
      picture: z.string().optional(),
      customInvoiceField: z.string().optional(),
    })
    .refine(
      (e) =>
        (!e.mobileNumber && !e.emergencyContact) ||
        !e.mobileNumber ||
        !e.emergencyContact,
      {
        message: "validation.noDuplicateContact",
      },
    );

export const MemberSchemaHelper = {
  schema: MemberSchema,
  defaultValues: {
    mobileNumber: undefined,
    dateBirth: undefined,
    gender: undefined,
    personalNumber: undefined,
    addressLine1: undefined,
    addressLine2: undefined,
    postCode: undefined,
    city: undefined,
    emergencyContactName: undefined,
    emergencyContact: undefined,
    picture: undefined,
    customInvoiceField: undefined,
  },
};
